// extracted by mini-css-extract-plugin
export default {"iconButton":"Button_iconButton__d2IXT"};